import '../scss/app.scss'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


document.querySelectorAll('.animation-container').forEach((container) => {
  const due = container.querySelector('.due');
  const tre = container.querySelector('.tre');
  if (!due || !tre) return;

  gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: "top 80%",
      end: "top 10%",
      scrub: 1.3,
      invalidateOnRefresh: true,
    }
  })
  .to(due, {
    x: () => -Math.min(due.offsetWidth, container.offsetWidth * 0.4),
    ease: "none",
  })
  .to(tre, {
    x: () => Math.min(tre.offsetWidth, container.offsetWidth * 0.4),
    ease: "none",
  }, "<");
});

document.querySelectorAll('.line').forEach((line) => {
  const balls = line.querySelectorAll('.ball');
  if (!balls.length) return;

  gsap.to(balls, {
    x: () => Math.max(line.offsetWidth - balls[0].offsetWidth, 0),
    stagger: {
      each: 0.1,
      ease: "power1.inOut"
    },
    filter: "blur(0px)",
    backgroundColor: "#0048C1",
    ease: "power2.inOut",
    force3D: true,
    scrollTrigger: {
      trigger: line,
      start: "top 90%",
      end: "bottom 10%",
      scrub: 1.5,
      invalidateOnRefresh: true,
    }
  });
});


if (document.querySelectorAll('#news-container').length > 0) { 
    let page = 1;
    let category = '';
    
    const container = document.getElementById('news-container');
    const loadMoreBtn = document.getElementById('load-more-btn');
    const filterLinks = document.querySelectorAll('#category-filter-list a');

    async function loadNews(append = false) {
        const formData = new FormData();
        formData.append('action', 'load_more_news');
        formData.append('page', page);
        formData.append('category', category);

        loadMoreBtn.textContent = 'Loading...';
        loadMoreBtn.disabled = true;

        try {
            const response = await fetch(ajax_posts.ajaxurl, {
                method: 'POST',
                body: formData
            });
            const html = await response.text();

            if (html.trim() !== '') {
                if (append) {
                    container.insertAdjacentHTML('beforeend', html);
                } else {
                    container.innerHTML = html;
                }
                loadMoreBtn.textContent = 'Load more news';
                loadMoreBtn.disabled = false;
                loadMoreBtn.style.display = 'block';
                page++;
            } else {
                if (!append) container.innerHTML = '<p>Nessun articolo trovato.</p>';
                loadMoreBtn.style.display = 'none';
            }
        } catch (error) {
            console.error('Errore:', error);
        }
    }

    // Gestione clic sulla lista
    filterLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            // Rimuovi classe active dagli altri e aggiungila a questo
            filterLinks.forEach(l => l.classList.remove('active'));
            this.classList.add('active');

            // Aggiorna categoria e resetta pagina
            category = this.getAttribute('data-category');
            page = 1;
            loadNews(false);
        });
    });

    loadMoreBtn.addEventListener('click', () => loadNews(true));
    loadNews(); // Caricamento iniziale
}

const header = document.querySelector('.header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY >= 100);
  }, { passive: true });
}

document.querySelectorAll('.stagger-in').forEach((el) => {
  const uniqueElements = [...el.querySelectorAll('.stagger-in__el')]
    .filter((child) => child.closest('.stagger-in') === el);

  if (!uniqueElements.length) return;

  gsap.fromTo(uniqueElements,
    { opacity: 0, yPercent: 50 },
    {
      opacity: 1,
      yPercent: 0,
      duration: 0.8,
      stagger: { each: 0.2 },
      scrollTrigger: {
        trigger: el,
        start: "top 75%",
      }
    }
  );
});

document.querySelectorAll('.animated-cta').forEach((cta) => {
  const elementsToAnimate = cta.querySelectorAll('.tag2, .ball2');
  if (!elementsToAnimate.length) return;

  gsap.fromTo(elementsToAnimate,
    { y: -400, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 1.5,
      ease: "bounce.out",
      stagger: 0.2,
      scrollTrigger: {
        trigger: cta,
        start: "top 80%",
        toggleActions: "play none none none",
      }
    }
  );
});

window.addEventListener('load', () => {
  ScrollTrigger.refresh();
  document.querySelectorAll('.swiper-team').forEach((el) => {
    if (el.swiper) el.swiper.update();
  });
});

const hamburger = document.getElementById("hamburger");
const mobileMenu = document.getElementById("mobile-menu");

if (hamburger && mobileMenu) {
  const menuTimeline = gsap.timeline({ paused: true });

  menuTimeline
    .to(mobileMenu, {
      duration: 0.5,
      opacity: 1,
      pointerEvents: "all",
      ease: "power2.out"
    })
    .to(hamburger.querySelector("span:nth-child(2)"), {
      duration: 0.3,
      width: 0,
      ease: "power2.inOut"
    }, 0)
    .to(hamburger.querySelector("span:nth-child(1)"), {
      duration: 0.3,
      y: 9,
      rotate: 45,
      ease: "power2.inOut"
    }, 0)
    .to(hamburger.querySelector("span:nth-child(3)"), {
      duration: 0.3,
      y: -8,
      rotate: -45,
      ease: "power2.inOut"
    }, 0);

  let menuOpen = false;
  hamburger.addEventListener("click", () => {
    menuOpen = !menuOpen;
    hamburger.classList.toggle('opened', menuOpen);
    if (menuOpen) {
      menuTimeline.play();
    } else {
      menuTimeline.reverse();
    }
  });
}


if (document.querySelectorAll('.swiper-partners').length > 0) {
    var swiper3 = new Swiper(".swiper-partners", {
      loop: true,
      slidesPerView: "auto",
      freeMode: true,
      allowTouchMove: false,
      autoplay: {
      delay: 0,
        disableOnInteraction: false,
      },
      spaceBetween: 80,
      speed: 4500,
    });
}

document.querySelectorAll('.swiper-team').forEach((el) => {
    const root = el.closest('.team') || document;
    new Swiper(el, {
      loop: false,
      spaceBetween: 8,
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      speed: 500,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      roundLengths: true,
      navigation: {
        nextEl: root.querySelector('.swiper-button-next.btn-team'),
        prevEl: root.querySelector('.swiper-button-prev.btn-team'),
      },
      breakpoints: {
        768: {
          slidesPerView: 1.4,
          spaceBetween: 8,
        },
        960: {
          slidesPerView: 2.2,
          spaceBetween: 8,
        },
        1200: {
          slidesPerView: 3.2,
          spaceBetween: 24,
          slidesOffsetAfter: 24,
        },
        1300: {
          slidesPerView: 3.5,
          spaceBetween: 32,
          slidesOffsetAfter: 32,
        },
      },
    });
});

if (document.querySelectorAll('.swiper-corsi').length > 0) {
    var swiper3 = new Swiper(".swiper-corsi", {
      loop: true,
      spaceBetween: 8,
      freemode: "true",
      slidesPerView: 1.2,
      navigation: {
        nextEl: ".swiper-button-next.btn-corsi",
        prevEl: ".swiper-button-prev.btn-corsi",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.4,
          spaceBetween: 8,
        },
        960: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1300: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      }, 
    });
}


if (document.querySelectorAll('.swiper-news').length > 0) {
    var swiper4 = new Swiper(".swiper-news", {
      loop: true,
      spaceBetween: 8,
      freemode: "true",
      slidesPerView: 1.2,
      navigation: {
        nextEl: ".swiper-button-next.btn-news",
        prevEl: ".swiper-button-prev.btn-news",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.4,
          spaceBetween: 8,
          slidesOffsetAfter: 8,
        },
        960: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1300: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      }, 
    });
}


if (document.querySelectorAll('.swiper-gallery').length > 0) {
    var swiper3 = new Swiper(".swiper-gallery", {
      loop: false,
      spaceBetween: 8,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next.btn-gallery",
        prevEl: ".swiper-button-prev.btn-gallery",
      },
      breakpoints: {
        640: {
          slidesPerView: 1.2,
          spaceBetween: 8,
          slidesOffsetAfter: 8,
        },
        960: {
          slidesPerView: 1.8,
          spaceBetween: 16,
          slidesOffsetAfter: 16,
        },
        1300: {
          slidesPerView: 2.4,
          spaceBetween: 24,
          slidesOffsetAfter: 24,
        },
        1500: {
          slidesPerView: 2.8,
          spaceBetween: 32,
          slidesOffsetAfter: 32,
        },
      }, 
    });
}

if (document.querySelectorAll('.swiper-servizi').length > 0) {
    var swiperNav = new Swiper(".swiper-servizi", {
        loop: false,
        spaceBetween: 12,
        slidesPerView: "auto",
        freeMode: false,
        watchSlidesProgress: true,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
    });

    var swiperMain = new Swiper(".swiper-elenco", {
        loop: false,
        spaceBetween: 8,
        slidesOffsetAfter: 8,
        slidesPerView: 1.1,
        thumbs: {
            swiper: swiperNav,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
        },
        breakpoints: {
            640: { slidesPerView: 1.1, spaceBetween: 8, slidesOffsetAfter: 8 },
            1200: { slidesPerView: 1.1, spaceBetween: 16, slidesOffsetAfter: 16 },
            1300: { slidesPerView: 1.2, spaceBetween: 32, slidesOffsetAfter: 32 },
        },
    });
}

if (document.querySelectorAll('.download').length > 0) {
  const closeBtn = document.querySelector('.close');
  const downloadDiv = document.querySelector('.download');

  closeBtn.addEventListener('click', () => {
    downloadDiv.classList.add('fade-out');

    downloadDiv.addEventListener('transitionend', () => {
      downloadDiv.remove(); 
    }, { once: true });
  });
}